"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Widget = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Widget = ({ school, headingtext, hideheading, includepadding, hidesidebar, modalmode, modalbuttonlabel, testmode, type, showfeetable, showperterm, }) => {
    return ((0, jsx_runtime_1.jsx)("div", { id: "feesable", "data-school": school, "data-headingtext": !hideheading && headingtext, "data-includepadding": includepadding, "data-hideheading": hideheading, "data-hidesidebar": hidesidebar, "data-modalmode": modalmode, "data-modalbuttonlabel": modalbuttonlabel, "data-testmode": testmode, "data-type": type, "data-showfeetable": showfeetable, "data-showperterm": showperterm, style: { width: '100%' } }));
};
exports.Widget = Widget;
